const ASL_CONTENT_SELECT_ONE = 'Select';
const ASL_CONTENT_INVITE = ' Invite ';
const ASL_CONTENT_SELECT_TWO = 'at the bottom of the page to add an interpreter to the group visit.';
const ASL_CONTENT_GROUP_VISIT = 'Non-verbal interpreters are the only option available for group visits.';
export { ASL_CONTENT_SELECT_ONE, ASL_CONTENT_INVITE, ASL_CONTENT_SELECT_TWO, ASL_CONTENT_GROUP_VISIT };
